// Port of api/fuel/app/classes/filter/search/games/filters/query/game/weight/count.php
export default {
	name: 'game.weight.count',
	priority: 26,
	require: function(config, filter) { return filter.threshold && filter.threshold.weight > 0 },
	run: function(config, filter, data, query) {
		query.where('g.game_weight_count', '>=', filter.threshold.weight)
	}
}
